module.exports = __webpack_public_path__ + "img/header-bg-mb.a5d7067.webp";